import React, { Fragment, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  Col,
  Row,
  Button,
  NavItem,
  NavLink,
  UncontrolledTooltip,
  UncontrolledButtonDropdown,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";
import { toast, Bounce } from "react-toastify";
import { faAngleDown, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import avatar1 from "../../../../assets/utils/images/avatars/user.png";
import { fireChangePassword, closeAlert } from "../../Alerts/sweet";
import { handleApiErrors } from "../../Alerts/errors";

import * as actions from "../../../../reducers/UserOptions";

import api from "../../../../api";
import version  from "../../../../../package.json";

const ChangePasswordForm = ({ onSubmit }) => {
  const [form, setForm] = useState({});
  const [options, setOptions] = useState({
    newPassword: true,
    oldPassword: true
  });

  const ref = useRef(null);

  useEffect(() => {
    ref.current.focus();
  }, []);

  const handleChange = e =>
    setForm({ ...form, [e.currentTarget.id]: e.currentTarget.value });

  const handleClick = option => {
    setOptions({ ...options, [option]: !options[option] });
  };

  return (
    <Form
      onSubmit={e => {
        e.preventDefault();
        onSubmit(form);
      }}
    >
      <FormGroup>
        <Label htmlFor="oldPassword">Parola veche</Label>
        <div style={{ display: "flex" }}>
          <Input
            style={{ position: "relative" }}
            innerRef={ref}
            onChange={handleChange}
            type={options.oldPassword ? "password" : "text"}
            id="oldPassword"
          />
          <FontAwesomeIcon
            id="oldPassword"
            onClick={e => handleClick("oldPassword")}
            style={{ position: "absolute", right: "80px", marginTop: "9px" }}
            icon={faEye}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Label htmlFor="newPassword">Parola noua</Label>
        <div style={{ display: "flex" }}>
          <Input
            style={{ position: "relative" }}
            onChange={handleChange}
            type="password"
            id="newPassword"
            // type={options.newPassword ? "password" : "text"}
          />
          <FontAwesomeIcon
            id="newPassword"
            onClick={e => handleClick("newPassword")}
            style={{ position: "absolute", right: "80px", marginTop: "9px" }}
            icon={faEye}
          />
        </div>
        <small style={{ color: "#e0004d" }}>*Minim 6 caractere</small>
      </FormGroup>
      <FormGroup>
        <Label htmlFor="newPasswordSecond">Reintro parola </Label>
        <div style={{ display: "flex" }}>
          <Input
            style={{ position: "relative" }}
            onChange={handleChange}
            type={options.newPassword ? "password" : "text"}
            id="newPasswordSecond"
          />
          <FontAwesomeIcon
            id="newPassword"
            onClick={e => handleClick("newPassword")}
            style={{ position: "absolute", right: "80px", marginTop: "9px" }}
            icon={faEye}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Button type="submit" className="second" size="lg">
          Confirma
        </Button>
      </FormGroup>
    </Form>
  );
};

class UserBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
  }

  notify2 = () =>
    (this.toastId = toast(
      "You don't have any new items in your calendar for today! Go out and play!",
      {
        transition: Bounce,
        closeButton: true,
        autoClose: 5000,
        position: "bottom-center",
        type: "success"
      }
    ));

  handleChangePassword = () => {
    fireChangePassword(
      "Schimbare parola",
      <ChangePasswordForm
        onSubmit={async form => {
          if (
            !form.newPassword ||
            !form.newPasswordSecond ||
            !form.oldPassword
          ) {
            return toast.error("Formular incorect");
          }

          if (
            form.newPassword.length < 6 ||
            form.newPasswordSecond.length < 6
          ) {
            return toast.error("Numar de caractere invalid");
          }

          if (form.newPassword !== form.newPasswordSecond) {
            return toast.error("Parolele nu corespund");
          }

          try {
            await api.put("users/v1/changePassword", { newPassword: form.newPassword, oldPassword: form.oldPassword });

            closeAlert();

            toast.success("Parola a fost modificata, folositi noua parola pentru login");
            localStorage.removeItem("TOKEN");
            window.location.replace("#/login")
          } catch (error) {
            handleApiErrors(error);
          }
        }}
      />
    );
  };

  render() {
    const firstname = this.props.user.name
      ? this.props.user.name.firstname
      : "";
    const lastname = this.props.user.name ? this.props.user.name.lastname : "";

    return (
      <Fragment>
        <div className="header-btn-lg pr-0">
          <div className="widget-content p-0">
            <div className="widget-content-wrapper">
              <div className="widget-content-left">
                <UncontrolledButtonDropdown>
                  <DropdownToggle color="link" className="p-0">
                    <img
                      width={42}
                      className="rounded-circle"
                      src={avatar1}
                      alt=""
                    />
                    <FontAwesomeIcon
                      className="ml-2 opacity-8"
                      icon={faAngleDown}
                    />
                  </DropdownToggle>
                  <DropdownMenu right className="rm-pointers dropdown-menu-lg">
                    <div className="dropdown-menu-header">
                      <div className="dropdown-menu-header-inner bg-info">
                        <div className="menu-header-content text-left">
                          <div className="widget-content p-0">
                            <div className="widget-content-wrapper">
                              <div className="widget-content-left mr-3">
                                <img
                                  width={42}
                                  className="rounded-circle"
                                  src={avatar1}
                                  alt=""
                                />
                              </div>
                              <div className="widget-content-left">
                                <div className="widget-heading">
                                  {firstname} {lastname}
                                </div>
                                <div className="widget-subheading opacity-8">
                                  Utilizator
                                </div>
                              </div>
                              <div className="widget-content-right mr-2">
                                <Button
                                  className="btn-pill btn-shadow btn-shine"
                                  color="focus"
                                  onClick={() => {
                                    window.location.replace("#/login");

                                    this.props.purge();
                                    localStorage.removeItem("TOKEN");
                                  }}
                                >
                                  Iesire
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="scroll-area-xs"
                      style={{
                        height: "150px"
                      }}
                    >
                      <PerfectScrollbar>
                        <Nav vertical>
                          <NavItem className="nav-item-header">
                            Setari utilizator
                          </NavItem>
                          <NavItem>
                            <Button
                              color="link"
                              onClick={this.handleChangePassword}
                              className="ft-2"
                            >
                              Schimba parola
                            </Button>
                          </NavItem>
                          <NavItem>
                            <Button
                              color="link"
                              onClick={() => {
                                window.location.replace("#/login");

                                // this.props.purge();
                                localStorage.removeItem("persist:root");
                                window.location.reload();
                              }}
                              className="ft-2"
                            >
                              Reconfigurare setari utilizator !!!
                            </Button>
                          </NavItem>
                        </Nav>
                      </PerfectScrollbar>
                    </div>
                    <Nav vertical>
                      <NavItem className="nav-item-divider mb-0" />
                    </Nav>
                    {/* <div className="grid-menu grid-menu-2col">
                      <Row className="no-gutters">
                        <Col sm="6">
                          <Button
                            className="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2"
                            outline
                            color="warning"
                          >
                            <i className="pe-7s-chat icon-gradient bg-amy-crisp btn-icon-wrapper mb-2">
                              {" "}
                            </i>
                            Message Inbox
                          </Button>
                        </Col>
                        <Col sm="6">
                          <Button
                            className="btn-icon-vertical btn-transition btn-transition-alt pt-2 pb-2"
                            outline
                            color="danger"
                          >
                            <i className="pe-7s-ticket icon-gradient bg-love-kiss btn-icon-wrapper mb-2">
                              {" "}
                            </i>
                            <b>Support Tickets</b>
                          </Button>
                        </Col>
                      </Row>
                    </div> */}
                    {/* <Nav vertical>
                      <NavItem className="nav-item-divider" />
                      <NavItem className="nav-item-btn text-center">
                        <Button size="sm" className="btn-wide" color="primary">
                          Open Messages
                        </Button>
                      </NavItem>
                    </Nav> */}
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              </div>
              <div className="widget-content-left  ml-3 header-user-info">
                <div className="widget-heading">
                  {firstname} {lastname}
                </div>
                <div className="widget-subheading">Utilizator global ({version.version})</div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.UserOptions.user
});

const mapDispatchToProps = dispatch => ({
  purge: () => dispatch(actions.purge())
});

export default connect(mapStateToProps, mapDispatchToProps)(UserBox);
